export enum PaymentInformationProperties {
  Account = 'account',
  CardNumber = 'cardNumber',
  Expiration = 'expiration',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum PaymentInformationMetaProperties {
  AccountId = 'Account-id',
  AccountVersion = 'Account-version',
}
